<template>
  <page no-styling>
    <div>
      <dashboard-data class="card pa0"/>

      <div class="card-spacing" />

      <campaign-carousel/>

    </div>
  </page>
</template>

<script>
import CampaignCarousel from '@/components/campaigns/CampaignCarousel.vue';
import DashboardData from '@/components/dashboard_data/DashboardData.vue';

export default {
  name: 'dashboard',

  components: { CampaignCarousel, DashboardData },
};
</script>
